<template>
  <div>
    {{ product.description }}
  </div>
</template>

<script>

export default {
  props: {
    product: {},
  },


  methods : {

  }
};
</script>

<style>
</style>